import { render } from "./SocialLayout.vue?vue&type=template&id=745cf7c6&ts=true"
import script from "./SocialLayout.vue?vue&type=script&lang=ts"
export * from "./SocialLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__